import { useItem } from '@/composables/item'
import { taskService } from '@/services/api'
import { defineStore, acceptHMRUpdate } from 'pinia'

export const useTaskStore = defineStore('task', () => {
	const { items, show, create, remove, update, attach, detach, getItem } =
		useItem(taskService, 'tasks', 'Task', {
			options: { saveCreated: false },
		})

	const documentBinary = taskService.binary

	return {
		getItem,
		items,
		show,
		create,
		update,
		remove,
		attach,
		detach,
		documentBinary,
	}
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useTaskStore, import.meta.hot))
}
